import MainLayout from "./components/common/layouts/mainLayout/MainLayout";
import HomePage from "./pages/public/homePage/HomePage";
import MyActivity from "./pages/public/myActivity/MyActivity";
import NotFound from "./pages/public/notFound/NotFound";
const publicRoutes = [
  {
    index: true,
    element: <HomePage />,
    //   loader: rootLoader,
  },
  {
    path: "/my-activity",
    element: <MyActivity />,
    //   loader: rootLoader,
  },
];
 
export const Routes = [
  {
    path: "/",
    element: <MainLayout />,
    errorElement: <NotFound />,
    children: publicRoutes,
  },
];
